// removed by extract-text-webpack-plugin
module.exports = {"sidebar-padding":"_2Zf7U","sidebar-margin":"_34XwL","sidebar":"_2PUaE _313Gh","breadcrumbs":"_3sX75 _2Zf7U","item":"ZnhzA _1-OXK _3Xg8b _313Gh _2Zf7U _2M9f_ _2AkTq","sectionTitle":"_215_z _1-OXK _3Xg8b _313Gh _2Zf7U _3-Uvz _1v96X","icon":"jY8eT b24O2","selected":"_3yen7","divider":"_1VyNk _3HYbc _1YmAR _34XwL","name":"_1HFtV _1Zj0B _1v96X","noLabelsMessage":"zShLD _1Q5o6 _3MLH0 _2Eplg K1PCN _2cEiq _34XwL"};


//////////////////
// WEBPACK FOOTER
// ./components/Sidebar.css
// module id = 275
// module chunks = 3